export type NetworkVendorMixWidget = {
  key: 'NetworkVendorMix';
  props: Record<string, never>;
};

export type HostVendorMixWidget = {
  key: 'HostVendorMix';
  props: Record<string, never>;
};

export type TextRowWidget = {
  key: 'TextRow';
  props: {
    variables: string;
  };
};

export type TableColorWidget = {
  key: 'TableColor';
  props: {
    name: string;
    group: string;
    absolute: boolean;
    displayType: 'table' | 'stackedBarChart' | 'pieChart';
  };
};

export type Widget =
  | NetworkVendorMixWidget
  | HostVendorMixWidget
  | TextRowWidget
  | TableColorWidget;

export type DashboardColumn = {
  title: string;
  widgets: Widget[];
  className: string;
  columnOrientation: 'vertical' | 'horizontal';
};

export type DashboardRow = {
  key: string;
  columns: DashboardColumn[];
};

export type DashboardTab = {
  rows: DashboardRow[];
  slug: string;
  title: string;
};
